import { memo } from 'react';
import ResizableSortTH from '../../resizing/components/ResizableSortTH';
import { jsx as _jsx } from "react/jsx-runtime";
const Header = ({
  column,
  columnIndex,
  columnPosition,
  isLastColumn,
  sortDirection,
  onColumnWidthChange,
  onColumnOrderChange,
  onSortChange,
  numberOfFrozenColumns
}) => /*#__PURE__*/_jsx(ResizableSortTH, {
  column: column,
  columnIndex: columnIndex,
  columnPosition: columnPosition,
  isLastColumn: isLastColumn,
  numberOfFrozenColumns: numberOfFrozenColumns,
  sortDirection: sortDirection,
  onColumnWidthChange: onColumnWidthChange,
  onColumnOrderChange: onColumnOrderChange,
  onSortChange: onSortChange,
  children: /*#__PURE__*/_jsx(column.HeaderContentComponent, {
    columnNamespace: column.columnNamespace,
    columnName: column.columnName
  })
});
export default /*#__PURE__*/memo(Header);